import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LayoutActionLoadError } from '@shared/store/actions/layout.action';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { ClaimAction } from './claim.actions';
import { ClaimService } from '../services/claim.service';

@Injectable()
export class ClaimEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly logger: NGXLogger,
    private readonly claimService: ClaimService
  ) {}

  claimListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClaimAction.claimListRequest),
      tap((_) => this.logger.debug('@Effect [Claim] Claim List Request')),
      switchMap(({ payload }) => {
        return this.claimService.getClaimList({ ...payload }).pipe(
          map((response) => {
            return ClaimAction.claimListResponse({ response });
          }),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });

  claimViewRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClaimAction.claimViewRequest),
      tap((_) => this.logger.debug('@Effect [Claim] Claim View Request')),
      switchMap(({ payload }) => {
        return this.claimService.getClaimView({ ...payload }).pipe(
          map((response) => {
            return ClaimAction.claimViewResponse({ response });
          }),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });
}
